import { FC } from 'react';
import cls from 'classnames';
import { useTranslation } from 'react-i18next';
import CloseComment from './assets/close-comment.svg';

import './style.scss';

export const CommentNoPermission: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="article-comment-no-permission">
      <p className={cls('article-comment-no-permission-title')}>{t('comment')}</p>
      <div className="article-comment-no-permission-content">
        <div className="article-comment-no-permission-image">
          <CloseComment />
        </div>
        <p className="article-comment-no-permission-text">{t('postPrivacy_allowComments_offStatus_other')}</p>
      </div>
    </div>
  );
};
